import { HttpClient } from '../../protocols/http/httpClient'
import {
  BankStatementEntries,
  IBankStatementEntries
} from '../../../domain/usecases/BankStatementEntries'
import {
  BankStatementEntry,
  BankStatementEntryListResponse
} from '../../../domain/models/BankStatementEntryModel'
import { throwIfHttpError } from '../../../validation/httpError'

export class RemoteBankStatementEntries implements IBankStatementEntries {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async list(
    params: BankStatementEntries.ListParams
  ): Promise<BankStatementEntryListResponse> {
    return this.httpClient.get?.({
      url: `${this.url}/bank-statement-entries`,
      data: params
    })
  }

  async sync(): Promise<{ created: number; matched: number }> {
    const response = await this.httpClient.post?.({
      url: `${this.url}/bank-statement-entries/sync`,
      data: {}
    })
    return throwIfHttpError(response, 'Erro ao sincronizar com Itaú')
  }

  async link({
    id,
    standalone_billing_id
  }: BankStatementEntries.LinkParams): Promise<BankStatementEntry> {
    const response = await this.httpClient.post?.({
      url: `${this.url}/bank-statement-entries/${id}/link`,
      data: { standalone_billing_id }
    })
    return throwIfHttpError(response, 'Erro ao linkar cobrança')
  }

  async unlink({
    id
  }: BankStatementEntries.UnlinkParams): Promise<BankStatementEntry> {
    const response = await this.httpClient.post?.({
      url: `${this.url}/bank-statement-entries/${id}/unlink`,
      data: {}
    })
    return throwIfHttpError(response, 'Erro ao desvincular cobrança')
  }
}
